import type { FaireProductEntity } from "../../entity_types/product";

export const p_2v2cpgq87z: FaireProductEntity = {
  token: "p_2v2cpgq87z",
  type: "product",
  name: "Mountain of Thanks Card",
  brandToken: "b_96blrd2y",
  brandName: "Tender Loving Empire",
  imageUrl:
    "https://cdn.faire.com/fastly/e281d8e8ba56af9544fee9e1667ec03dac3d25cc5c55ee1800f4f91d4cd4ef13.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/845a66872bf6b05647f09debe34e3b4c1f01e4d9d21a93914778eb60d114b50a.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "This card is blank inside. Comes in a cello sleeve with a white envelope.\n\nSize A2 flat - 4.25 x 5.5 inches. SKU printed on back.\n\nDesigned and printed locally in Portland, Oregon.\n\nThank You Card, Mother's Day Card, Father's Day Card, Greeting Card, Mountain Outdoors Hike Waterfall Wildflowers Flowers Sunrise Sunset Valley",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:15.671Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
